module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAALCAYAAACZIGYHAAAA20lEQVQokZ3QMSuFYRjG8etgOpwy28WkjHwKxSKL3QfwDWSzyGRgJNNZDD6AMilKmZQsNjLKT2+eV8fpfTm56nrqfp6r/33fTwdp0XaSuyT9tkCtsYa7XpKjJLtJun8BKk0M1QsFsFjq11Egg+tsJNlPMj3wfpLkOslHksckt8U//wA97BlN77jCZtW8dnUcjwgY1hmmasgczv8JOkWnHmkcOw2hJ9zgAS8toNXvvYrX8DwQWC8NJjGDJWyhj7eSuRiGVJ7HZQlU0KZM5Vkc4L4t0MUhVn6BfJnlT2stuIJyyL4CAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fh.png
// module id = dI/+
// module chunks = 1